import React, { useRef } from "react";
import "./DateInputDdMmYyyy.scss";

function DateInputDdMmYyyy({
  label,
  value,
  onChange,
  minDate,
  maxDate,
  required = false,
  fullWidth = true,
}) {
  const inputRef = useRef(null);

  const displayValue = value
    ? value.split("-").reverse().join(".")
    : "";

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`rfm-date-field${fullWidth ? " rfm-date-field--full" : ""}`}>
      <div className="rfm-date-input-wrap" onClick={() => inputRef.current?.showPicker?.()}>
        <span className="rfm-date-display">
          {displayValue || <span className="rfm-date-placeholder">dd.mm.yyyy</span>}
        </span>
        <input
          ref={inputRef}
          type="date"
          required={required}
          value={value}
          min={minDate}
          max={maxDate}
          onChange={handleChange}
          className="rfm-date-native"
        />
        <svg className="rfm-date-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        {label && (
          <span className="rfm-date-floating-label">
            {label}{required && <span className="rfm-date-required"> *</span>}
          </span>
        )}
      </div>
    </div>
  );
}

export default DateInputDdMmYyyy;
